import { useContext } from 'react';
import { EventStatsBatchContext, type EventStatsBatchContextType } from '@/contexts/EventStatsContext';

/** Access the batched Ditto event-stats loader. Must be used within EventStatsProvider. */
export function useEventStatsBatch(): EventStatsBatchContextType {
  const context = useContext(EventStatsBatchContext);
  if (context === undefined) {
    throw new Error('useEventStatsBatch must be used within an EventStatsProvider');
  }
  return context;
}
